import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Custom-domain guard: if the bundle was built with the apex host (aitunerproportal.com)
// but the page is served from www (or vice-versa), rewrite API calls to the current origin.
// Cross-origin calls to the apex hit a 308 → www redirect that browsers refuse on CORS
// preflights ("Failed to fetch" / HTTP 520). Same-origin calls never redirect.
(function installBackendOriginGuard() {
  const configured = process.env.REACT_APP_BACKEND_URL;
  if (!configured || window.__backendOriginGuard) return;
  let cfg;
  try { cfg = new URL(configured); } catch { return; }
  const strip = (h) => h.replace(/^www\./, '');
  if (cfg.host === window.location.host || strip(cfg.host) !== strip(window.location.host)) return;
  const from = cfg.origin;
  const to = window.location.origin;
  const rewrite = (u) => (typeof u === 'string' && u.startsWith(from) ? to + u.slice(from.length) : u);

  const _fetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    if (typeof input === 'string') return _fetch(rewrite(input), init);
    if (input instanceof URL) return _fetch(rewrite(input.href), init);
    if (input instanceof Request && input.url.startsWith(from)) return _fetch(new Request(rewrite(input.url), input), init);
    return _fetch(input, init);
  };
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) { return _open.call(this, method, rewrite(String(url)), ...rest); };
  window.__backendOriginGuard = { from, to };
})();

// Global fetch wrapper — intercepts 402 trial-expired responses and fires a
// 'trial-expired' window event. App.js listens for it and shows the modal.
// We use the `x-trial-expired` response header (sent by the backend) instead
// of re-reading the body, because react-scripts dev HMR can consume the body
// before any callsite reads it, causing `clone()` to fail.
if (!window.__trialFetchWrapped) {
  const _origFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const resp = await _origFetch(input, init);
    if (resp.status === 402 && resp.headers.get('x-trial-expired') === '1') {
      window.dispatchEvent(new CustomEvent('trial-expired', {
        detail: {
          code: 'trial_expired',
          message: 'Your 14-day free trial has ended. Subscribe or apply as a beta tester to keep using AI features.',
          upgrade_url: '/#pricing',
        },
      }));
    }
    return resp;
  };
  window.__trialFetchWrapped = true;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
